/**
 * BulkUserActions.js
 * Centralized component for bulk user actions:
 * - "Invia Email" (Broadcast modal)
 * - "Invia Link Portale" (Bulk athlete access modal, admin only)
 */

import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { authService } from '../../services/api';
import { USER_ROLES } from '../../utils/constants';
import SendBroadcastEmailModal from './SendBroadcastEmailModal';
import SendBulkAthleteAccessModal from './SendBulkAthleteAccessModal';

const BulkUserActions = ({
  selectedUsers = [],
  onSuccess,
  onError,
  onClearSelection,
  className = 'me-2',
  buttonSize,
  showEmail = true,
  showPortalLink = true,
  emailButtonVariant = 'success',
  portalLinkButtonVariant = 'primary'
}) => {
  const isCurrentUserAdmin = authService?.hasRole ? authService.hasRole(USER_ROLES.ADMIN) : false;
  const [showBroadcastModal, setShowBroadcastModal] = useState(false);
  const [showBulkAccessModal, setShowBulkAccessModal] = useState(false);

  const count = selectedUsers.length;

  const handleOpenBroadcastModal = () => {
    setShowBroadcastModal(true);
  };

  const handleOpenBulkAccessModal = () => {
    setShowBulkAccessModal(true);
  };

  const handleBroadcastSuccess = (message) => {
    setShowBroadcastModal(false);
    if (onClearSelection) onClearSelection();
    if (onSuccess) onSuccess(message);
  };

  const handleBulkAccessSuccess = (message) => {
    setShowBulkAccessModal(false);
    if (onClearSelection) onClearSelection();
    if (onSuccess) onSuccess(message);
  };

  const handleBroadcastError = (err) => {
    if (onError) onError(err);
  };

  const handleBulkAccessError = (err) => {
    if (onError) onError(err);
  };

  if (count === 0 && !showBroadcastModal && !showBulkAccessModal) {
    return null;
  }

  return (
    <>
      {count > 0 && showEmail && (
        <Button
          variant={emailButtonVariant}
          size={buttonSize}
          className={className}
          onClick={handleOpenBroadcastModal}
        >
          <i className="fas fa-envelope me-2"></i>
          Invia Email ({count})
        </Button>
      )}

      {count > 0 && showPortalLink && isCurrentUserAdmin && (
        <Button
          variant={portalLinkButtonVariant}
          size={buttonSize}
          className={className}
          onClick={handleOpenBulkAccessModal}
        >
          <i className="fas fa-key me-2"></i>
          Invia Link Portale ({count})
        </Button>
      )}

      {/* Broadcast Email Modal */}
      <SendBroadcastEmailModal
        show={showBroadcastModal}
        onHide={() => setShowBroadcastModal(false)}
        selectedUserIds={selectedUsers.map(u => u.id)}
        selectedUsers={selectedUsers}
        onSuccess={handleBroadcastSuccess}
        onError={handleBroadcastError}
      />

      {/* Bulk Portal Access Modal */}
      <SendBulkAthleteAccessModal
        show={showBulkAccessModal}
        onHide={() => setShowBulkAccessModal(false)}
        selectedUsers={selectedUsers}
        onSuccess={handleBulkAccessSuccess}
        onError={handleBulkAccessError}
      />
    </>
  );
};

export default BulkUserActions;
